import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { getTenantRequest } from '../../../api/sportaloka-client';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

function RecentTenantApproval({ onFilterLengthChanged }) {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 5,
    sort_field: 'updated_at',
    sort_value: 'desc',
    status: [],
    site_name: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getStatusObject = (status) => {
    switch (status) {
      case 'NEW_REQUEST':
        return {
          color: 'yellow-4',
          textColor: 'yellow-3',
          label: 'NEW'
        };
      case 'APPROVED':
        return {
          color: 'green-1',
          textColor: 'green-2',
          label: 'ACTIVE'
        };
      case 'INACTIVE':
        return {
          color: 'red-3',
          textColor: 'red-1',
          label: 'INACTIVE',
          value: status
        };
      case 'REJECTED':
        return {
          color: 'red-3',
          textColor: 'red-1',
          label: 'REJECTED'
        };
      default:
        return {
          color: 'blue-1-05',
          textColor: 'blue-1',
          label: 'IN PROGRESS'
        };
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        status: ['NEW_REQUEST', 'WAITING_FOR_APPROVAL'],
        site_name: paginationOptions.site_name
      }).toString();
      const response = await getTenantRequest(query);
      const responseData = response.data.data.data.map((item) => ({
        ...item,
        status: getStatusObject(item.status)
      }));
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilter = (site_name, status) => {
    let filterLength = 0;
    if (site_name) {
      filterLength = filterLength + 1;
    }
    setPaginationOptions({ ...paginationOptions, status, site_name });
    onFilterLengthChanged(filterLength + status.length);
  };

  const handleSort = (field) => {
    const isAsc = paginationOptions.sort_field === field && paginationOptions.sort_value === 'asc';
    setPaginationOptions({
      ...paginationOptions,
      sort_field: field,
      sort_value: isAsc ? 'desc' : 'asc'
    });
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th className="nowrap text-14">Tanggal</th>
            <th className="nowrap text-14">Nama Site</th>
            <th className="nowrap text-14">Pemilik</th>
            <th className="nowrap text-14">Status</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center text-light-1" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td className="nowrap">{format(new Date(row.created_at), 'dd/MM/yyyy hh:mm')}</td>
              <td className="nowrap fw-500">{row.site_name ?? '-'}</td>
              <td className="nowrap">{row.users[0] ? row.users[0].fullname : '-'}</td>
              <td className="nowrap">
                <div
                  className={`rounded-100 py-4 d-inline px-10 text-center col-12 text-14 fw-600 bg-${row.status.color} text-${row.status.textColor}`}>
                  {row.status.label}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RecentTenantApproval;
